import { FC, InputHTMLAttributes } from 'react';
import { UseFormRegisterReturn } from 'react-hook-form';
import classNames from 'classnames';

import classes from './input.module.css';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  id: string;
  type: string;
  className?: string;
  register?: UseFormRegisterReturn<string>; // react-hook-forms register
  isError?: boolean;
}

export const Input: FC<InputProps> = ({
  id, type, className, register, isError = false, ...rest
}) => {
  const defaultClassName = isError
    ? classNames(classes.inputError, classes.input) : classes.input;

  return (
    <input
      id={id}
      type={type}
      className={classNames(defaultClassName, className)}
      {...register}
      {...rest}
    />
  );
};

interface ErrorProps {
  message: string;
  className?: string;
  isError?: boolean;
}

export const InputError: FC<ErrorProps> = ({ message, className, isError = false }) => (
  <span className={className || classes.error}>{isError && message}</span>
);
